import { createNamespacedHelpers } from 'vuex-composition-helpers';
const { useState, useActions } = createNamespacedHelpers('goodsOffer');
export const useGoodsOffer = () => {
    const { currentGoodsOffer, isLoading, error } = useState([
        'currentGoodsOffer',
        'isLoading',
        'error',
    ]);
    const { fetchGoodsOffer, clearGoodsOffer } = useActions([
        'fetchGoodsOffer',
        'clearGoodsOffer',
    ]);
    return {
        currentGoodsOffer,
        isLoading,
        error,
        fetchGoodsOffer,
        clearGoodsOffer,
    };
};
